module.exports = __webpack_public_path__ + "img/Free Chart Image on Unsplash.dfa0bc38.png";